import * as ActionTypes from '../constants/ActionTypes'
import { getRequest } from './http'

export function loading() {
  return {
    type: ActionTypes.LOADING_CHANGE
  }
}

export function setData(items, name) {
  return {
    type: ActionTypes.DATA,
    name: name,
    items: items
  }
}

export function data_with_pagination(items, name) {
  return {
    type: ActionTypes.DATA_WITH_PAGINATION,
    name: name,
    items: items
  }
}

const getChild = (data, typeOption) => {
  data.typeOption = typeOption;
  return (dispatch) => {
    dispatch(loading());
    getRequest(data, "progress").then(
    (response) => {
      dispatch(setData(response.data.user, 'user'));
      dispatch(data_with_pagination(response.data.evidencias, 'eva'));
      dispatch(setData(response.data.docentes, 'doc'));
      dispatch(setData(response.data.headerb, 'headerb'));
      dispatch(setData(response.data.headers, 'headers'));
      dispatch(setData(response.data.notasbimensuales, 'nb'));
      dispatch(setData(response.data.notasevidencias, 'ne'));
      dispatch(setData(response.data.pays, 'pays'));
      dispatch(loading());
    },
    (err) => {
      dispatch(loading());
      if (err.response.status === 401) {
        dispatch(setData(true, 'error401'));
      }else{
        dispatch(setData(true, 'error'));
      }
    }
    );
  }
};

export default {
  getChild
}
